/*
* 返回选中日期当天的结束最后一秒  YYYY-MM-DD 23:59:59
*
* */
import React, {Component} from 'react';
import DatePickerClientS from "../DatePickerTimeZoneConversion";
require('./index.less');

export default class TZDatePickerEnd extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        //let Format = 'YYYY-MM-DD';
        let {
            format = ['YYYY-MM-DD', 'YYYYMMDD', 'YYYY.MM.DD', 'YYYY/MM/DD'],
            ...others
        } = this.props;
        return (
            <DatePickerClientS
                format={format}
                {...others}
                MultiTZ={true}
                dateInputPlaceholder='YYYYMMDD'
                HHmmss='23:59:59'
                className={`TZDatePickerEnd ${this.props.className}`}
            />
        );
    }
}
TZDatePickerEnd.defaultProps = {
    showTime: false,
    showClear: true,
    renderIcon: () => {
        return <i className="icon iconfont">&#xe6cd;</i>;
    },
};
